class NotificationEmitter {
  static add(message) {
    if (typeof document !== 'undefined') {
      const event = new CustomEvent('onNotification', {
        detail: {
          message,
        },
      });
      document.dispatchEvent(event);
    }
  }
}

export default NotificationEmitter;
